import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { CROP_FERTILIZATION_PLAN } from '../../../router/routes';
import {
  Tab,
  TabContainer,
  TabContents,
  TabLink,
  TabNavigation,
  useTab,
} from '../../../components/common/tabs/tab-container';
import Title from '../../../components/common/title';
import FertilizationPlanTableIndex from './plan';
import FertilizationPlanWarehouseTableIndex from './warehouse';

export enum FertilizationPlanTabKey {
  PLAN = 'plan',
  WAREHOUSE = 'warehouse',
}

export default function FertilizationPlan() {
  const { t } = useTranslation();
  const translationKeyPrefix = 'pages.crop.fertilization-plan.';
  const tp = useCallback(
    (key: string) => t(translationKeyPrefix.concat(key)),
    [t]
  );

  const [tab, setTab] = useTab(CROP_FERTILIZATION_PLAN, [
    'tab',
    'farmId',
    'season',
  ]);

  return (
    <>
      <Title title={tp('title')}></Title>
      <TabContainer
        selectedTabKey={tab}
        setTab={setTab}
        tabNavigation={
          <TabNavigation>
            <TabLink tabKey={FertilizationPlanTabKey.PLAN}>
              {tp('section.plan')}
            </TabLink>
            <TabLink tabKey={FertilizationPlanTabKey.WAREHOUSE}>
              {tp('section.warehouse')}
            </TabLink>
          </TabNavigation>
        }
        tabContents={
          <TabContents>
            <Tab tabKey={FertilizationPlanTabKey.PLAN}>
              <FertilizationPlanTableIndex />
            </Tab>
            <Tab tabKey={FertilizationPlanTabKey.WAREHOUSE}>
              <FertilizationPlanWarehouseTableIndex />
            </Tab>
          </TabContents>
        }
      />
    </>
  );
}
